@if (formControl()) {
<div class="json form-group">
    <mat-form-field class="form-field">
        <textarea class="area" matInput [rows]="$safeNavigationMigration(meta()?.rows)" [ngStyle]="textStyle" [placeholder]="$safeNavigationMigration(meta()?.name)"
            [formControl]="formControl()!" (change)="onChange($event)"></textarea>
        @if (formControl()?.value) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="formControl()?.setValue('')">
            <mat-icon>close</mat-icon>
        </button>
        }
        @if (meta()?.info) {
        <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('json')) {
        <mat-error>
            Invalid JSON format.
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
